/**
 * Nome da mostrare per un cliente.
 *
 * Vive fuori dai componenti perche' lo usano sia la riga della tabella sia
 * l'intestazione del pannello, e devono chiamare la stessa persona allo stesso modo.
 *
 * La catena di fallback e' quella dei dati reali: le richieste anonime possono arrivare
 * senza nome, e in quel caso l'email e' l'unica cosa che identifica il contatto. Il
 * `client_key` in coda e' l'ultima rete: e' l'email normalizzata, quindi comunque
 * leggibile.
 */
export function clientDisplayName(row: {
    first_name: string | null;
    last_name: string | null;
    email: string | null;
    client_key?: string;
}): string {
    return (
        [row.first_name, row.last_name].filter(Boolean).join(' ') ||
        row.email ||
        row.client_key ||
        ''
    );
}
